import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/hanging-email.svg'


const _hoisted_1 = { class: "my-2" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col gap-3"
}
const _hoisted_3 = { class: "flex justify-between items-start gap-6" }
const _hoisted_4 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_5 = { class: "flex flex-col items-end gap-2 w-40" }
const _hoisted_6 = { class: "flex flex-col gap-2" }
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col gap-y-2"
}
const _hoisted_8 = { class: "flex flex-col w-full ml-auto font-montserrat" }
const _hoisted_9 = { class: "flex items-center w-full ml-auto justify-between gap-x-6 pr-2 font-montserrat" }
const _hoisted_10 = { class: "flex flex-col gap-y-1" }
const _hoisted_11 = { class: "flex items-center gap-x-2 text-black-lp-200 font-bold text-base" }
const _hoisted_12 = {
  key: 0,
  class: "font-normal flex flex-row text-gray-lp-800 items-center"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("( ")
const _hoisted_14 = { class: "text-black-lp-200 mr-0.5" }
const _hoisted_15 = { class: "flex items-center justify-end gap-x-2 self-start" }
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4",
  alt: "hangng-email"
}, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "flex flex-col w-full"
}
const _hoisted_18 = { class: "flex items-center gap-x-2 relative" }
const _hoisted_19 = { class: "flex flex-row gap-x-2 py-2 px-4 font-normal text-base text-black-lp-200 bg-gray-lp-1000 rounded-xl" }
const _hoisted_20 = {
  key: 0,
  class: "border-r-2 border-red-lp-600 pr-2"
}
const _hoisted_21 = { class: "m-0 font-montserrat flex flex-col gap-y-3" }
const _hoisted_22 = { class: "flex items-center gap-x-2 relative mb-2" }
const _hoisted_23 = { class: "flex flex-row gap-x-2 py-2 px-4 font-normal text-base text-black-lp-200 bg-gray-lp-1000 rounded-xl" }
const _hoisted_24 = {
  key: 0,
  class: "border-r-2 border-red-lp-600 pr-2"
}
const _hoisted_25 = {
  key: 0,
  class: "overflow-hidden"
}
const _hoisted_26 = { class: "w-full" }
const _hoisted_27 = { class: "bg-gray-lp-700 text-sm text-gray-lp-300 font-semibold border-t-2 border-gray-lp-1400" }
const _hoisted_28 = /*#__PURE__*/_createVNode("th", { class: "py-2.5 w-1/12" }, [
  /*#__PURE__*/_createVNode("span", { class: "px-3 flex justify-start" }, " No. ")
], -1)
const _hoisted_29 = {
  key: 0,
  class: "py-2.5 w-2/12"
}
const _hoisted_30 = { class: "px-3 flex justify-start" }
const _hoisted_31 = { class: "py-2.5 w-2/12" }
const _hoisted_32 = { class: "px-3 flex justify-start" }
const _hoisted_33 = { class: "py-2.5 w-2/12" }
const _hoisted_34 = { class: "px-3 flex justify-start" }
const _hoisted_35 = /*#__PURE__*/_createVNode("th", { class: "py-2.5 w-1/12" }, [
  /*#__PURE__*/_createVNode("span", { class: "px-3 flex justify-start" }, " Hanging ")
], -1)
const _hoisted_36 = {
  key: 1,
  class: "py-2.5 w-2/12"
}
const _hoisted_37 = { class: "px-3 flex justify-start" }
const _hoisted_38 = { class: "py-2.5 w-2/12" }
const _hoisted_39 = { class: "px-3 flex justify-start" }
const _hoisted_40 = { class: "py-2.5 w-2/12" }
const _hoisted_41 = { class: "px-3 flex justify-start" }
const _hoisted_42 = {
  key: 0,
  class: "overflow-hidden border-2 border-gray-lp-1400 rounded-b-2xl"
}
const _hoisted_43 = { class: "w-full" }
const _hoisted_44 = { class: "text-left px-3 py-3 w-1/12" }
const _hoisted_45 = { class: "flex items-center gap-2 relative" }
const _hoisted_46 = {
  key: 0,
  class: "text-left px-3 py-3 font-bold w-2/12"
}
const _hoisted_47 = { class: "text-left px-3 py-3 w-2/12" }
const _hoisted_48 = { class: "flex flex-col items-start gap-1" }
const _hoisted_49 = { class: "font-bold" }
const _hoisted_50 = {
  key: 0,
  class: "font-normal text-xs px-2 rounded-lg bg-gray-lp-1000"
}
const _hoisted_51 = { class: "text-left px-3 py-3 font-bold w-2/12" }
const _hoisted_52 = { class: "text-left px-3 py-3 w-1/12" }
const _hoisted_53 = {
  key: 1,
  class: "text-left px-3 py-3 font-bold w-2/12"
}
const _hoisted_54 = { class: "text-left px-3 py-3 w-2/12" }
const _hoisted_55 = { class: "flex flex-col items-start gap-1" }
const _hoisted_56 = {
  key: 0,
  class: "text-gray-lp-300 font-normal text-10px"
}
const _hoisted_57 = { class: "text-left px-3 py-3 font-normal text-sm w-2/12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.skeletonCount, (n) => {
            return (_openBlock(), _createBlock("div", {
              key: n,
              class: "rounded-xl border border-gray-lp-1400 bg-white p-4 flex flex-col gap-4 animate-pulse"
            }, [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_Skeleton, {
                    height: "18px",
                    width: "35%"
                  }),
                  _createVNode(_component_Skeleton, {
                    height: "14px",
                    width: "55%"
                  })
                ]),
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_Skeleton, {
                    height: "16px",
                    width: "80%"
                  }),
                  _createVNode(_component_Skeleton, {
                    height: "16px",
                    width: "60%"
                  })
                ])
              ]),
              _createVNode("div", _hoisted_6, [
                (_openBlock(), _createBlock(_Fragment, null, _renderList(3, (i) => {
                  return _createVNode(_component_Skeleton, {
                    key: i,
                    height: "32px",
                    width: "100%"
                  })
                }), 64))
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_7, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(this.modelValue, (item, index) => {
            return (_openBlock(), _createBlock(_component_Accordion, {
              id: "accordion-hanging-incoming",
              key: item.id,
              onTabOpen: ($event: any) => (_ctx.onTabOpen(item)),
              onTabClose: ($event: any) => (_ctx.onTabClose(item))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AccordionTab, null, {
                  header: _withCtx(() => [
                    _createVNode("div", _hoisted_8, [
                      _createVNode("div", _hoisted_9, [
                        _createVNode("div", _hoisted_10, [
                          _createVNode("div", _hoisted_11, [
                            _createTextVNode(_toDisplayString(`${index + 1}. ${_ctx.mapActivityType(item).label}`) + " ", 1),
                            _createVNode("img", {
                              src: require(`@/app/ui/assets/svg/${_ctx.mapActivityType(item).icon}.svg`),
                              alt: "icon-hanging"
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("div", {
                            class: ["flex items-center gap-x-1 font-bold text-sm", _ctx.mapFollowUp(item).color]
                          }, [
                            _createVNode("img", {
                              class: "w-4",
                              src: require(`@/app/ui/assets/svg/${_ctx.mapFollowUp(item).icon}.svg`),
                              alt: "icon-folow-up"
                            }, null, 8, ["src"]),
                            _createTextVNode(" " + _toDisplayString(_ctx.mapFollowUp(item).label) + " ", 1),
                            (item.followUpStatus === 'sudah')
                              ? (_openBlock(), _createBlock("div", _hoisted_12, [
                                  _hoisted_13,
                                  _createVNode("span", _hoisted_14, _toDisplayString(item.followUpByUsername), 1),
                                  _createTextVNode(" • " + _toDisplayString(_ctx.formatDateToString(item.followUpAt)) + ") ", 1)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]),
                        _createVNode("div", _hoisted_15, [
                          (item.activityType !== 'follow_up_warehouse' && !_ctx.isFollowUpDone(item))
                            ? (_openBlock(), _createBlock("button", {
                                key: 0,
                                class: "border border-black-lp-200 text-black-lp-200 font-bold text-xs rounded-md px-3 h-8 flex items-center justify-center pointer-events-auto",
                                onClick: _withModifiers(($event: any) => (_ctx.onClickTemplate(item)), ["stop"])
                              }, [
                                _hoisted_16,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard.cardCollapsibleHanging.templateMessage')), 1)
                              ], 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (!_ctx.isFollowUpDone(item))
                            ? (_openBlock(), _createBlock("button", {
                                key: 1,
                                class: "border bg-black-lp-200 text-white font-bold text-xs rounded-md px-3 h-8 flex items-center justify-center pointer-events-auto",
                                onClick: _withModifiers(($event: any) => (_ctx.onConfirmDone(item)), ["stop"])
                              }, _toDisplayString(_ctx.$t('dashboard.cardCollapsibleHanging.confirmDone')), 9, ["onClick"]))
                            : _createCommentVNode("", true),
                          _createVNode("button", {
                            class: "border border-black-lp-100 rounded-md h-8 w-8 flex items-center justify-center pointer-events-auto",
                            onClick: _withModifiers(($event: any) => (_ctx.onDownload(item)), ["stop"])
                          }, [
                            _createVNode(_component_Icons, {
                              name: "download-new",
                              class: "w-4 text-red-lp-100"
                            })
                          ], 8, ["onClick"])
                        ])
                      ]),
                      (!item.isCollapsed)
                        ? (_openBlock(), _createBlock("div", _hoisted_17, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.groups, (group, groupIndex) => {
                              return (_openBlock(), _createBlock("div", {
                                key: `group-${index}-${groupIndex}`,
                                class: ["pt-2 flex flex-row", `${groupIndex < item.groups.length - 1 ? 'border-b-2 border-gray-lp-1400 pb-2' : ''}`]
                              }, [
                                _createVNode("div", _hoisted_18, [
                                  (_ctx.isCheckbox)
                                    ? (_openBlock(), _createBlock(_component_Checkbox, {
                                        key: 0,
                                        modelValue: group.isChecked,
                                        inputId: `group-checkbox-${index}-${groupIndex}`,
                                        binary: true,
                                        onClick: ($event: any) => (
                      _ctx.onUpdateGroup(group)
                    )
                                      }, null, 8, ["modelValue", "inputId", "onClick"]))
                                    : _createCommentVNode("", true),
                                  _createVNode("label", {
                                    for: `groupName-${groupIndex}`,
                                    class: "font-normal text-base text-black-lp-200"
                                  }, _toDisplayString(group.groupName), 9, ["for"]),
                                  _createVNode("div", _hoisted_19, [
                                    (!_ctx.isDashboardOutgoing)
                                      ? (_openBlock(), _createBlock("span", _hoisted_20, _toDisplayString(group.summary.totalManifest) + " Manifest", 1))
                                      : _createCommentVNode("", true),
                                    _createVNode("span", null, _toDisplayString(group.summary.totalStt) + " STT", 1)
                                  ])
                                ])
                              ], 2))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_21, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.groups, (group, groupIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          key: `group-${index}-${groupIndex}`,
                          class: "flex flex-col"
                        }, [
                          _createVNode("div", _hoisted_22, [
                            (_ctx.isCheckbox)
                              ? (_openBlock(), _createBlock(_component_Checkbox, {
                                  key: 0,
                                  modelValue: group.isChecked,
                                  inputId: `group-checkbox-${index}-${groupIndex}`,
                                  binary: true,
                                  onClick: ($event: any) => (
                  _ctx.onUpdateGroup(group)
                )
                                }, null, 8, ["modelValue", "inputId", "onClick"]))
                              : _createCommentVNode("", true),
                            _createVNode("label", {
                              for: `groupName-${groupIndex}`,
                              class: "font-normal text-base text-black-lp-200"
                            }, _toDisplayString(group.groupName), 9, ["for"]),
                            _createVNode("div", _hoisted_23, [
                              (!_ctx.isDashboardOutgoing)
                                ? (_openBlock(), _createBlock("span", _hoisted_24, _toDisplayString(group.summary.totalManifest) + " Manifest", 1))
                                : _createCommentVNode("", true),
                              _createVNode("span", null, _toDisplayString(group.summary.totalStt) + " STT", 1)
                            ])
                          ]),
                          _createVNode("div", null, [
                            (group.stts.length)
                              ? (_openBlock(), _createBlock("div", _hoisted_25, [
                                  _createVNode("table", _hoisted_26, [
                                    _createVNode("thead", _hoisted_27, [
                                      _hoisted_28,
                                      (!_ctx.isDashboardOutgoing)
                                        ? (_openBlock(), _createBlock("th", _hoisted_29, [
                                            _createVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('dashboard.cardCollapsibleHanging.manifestNo')), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createVNode("th", _hoisted_31, [
                                        _createVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('dashboard.cardCollapsibleHanging.sttNo')), 1)
                                      ]),
                                      _createVNode("th", _hoisted_33, [
                                        _createVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('dashboard.cardCollapsibleHanging.productType')), 1)
                                      ]),
                                      _hoisted_35,
                                      (_ctx.isDashboardOutgoing)
                                        ? (_openBlock(), _createBlock("th", _hoisted_36, [
                                            _createVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('dashboard.cardCollapsibleHanging.destinationCity')), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createVNode("th", _hoisted_38, [
                                        _createVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('dashboard.cardCollapsibleHanging.packageStatus')), 1)
                                      ]),
                                      _createVNode("th", _hoisted_40, [
                                        _createVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('dashboard.cardCollapsibleHanging.packageLocation')), 1)
                                      ])
                                    ])
                                  ]),
                                  (group.stts.length)
                                    ? (_openBlock(), _createBlock("div", _hoisted_42, [
                                        _createVNode("table", _hoisted_43, [
                                          _createVNode("tbody", null, [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(group.stts, (stt, sttIndex) => {
                                              return (_openBlock(), _createBlock("tr", {
                                                key: `stt-${index}-${groupIndex}-${sttIndex}`,
                                                class: "border-t border-gray-lp-1400 text-sm text-gray-lp-300"
                                              }, [
                                                _createVNode("td", _hoisted_44, [
                                                  _createVNode("div", _hoisted_45, [
                                                    (_ctx.isCheckbox)
                                                      ? (_openBlock(), _createBlock(_component_Checkbox, {
                                                          key: 0,
                                                          modelValue: stt.isChecked,
                                                          inputId: `stt-checkbox-${index}-${groupIndex}-${sttIndex}`,
                                                          binary: true,
                                                          onClick: ($event: any) => (
                                _ctx.onUpdateStt(stt, group)
                              )
                                                        }, null, 8, ["modelValue", "inputId", "onClick"]))
                                                      : _createCommentVNode("", true),
                                                    _createVNode("label", {
                                                      for: `stt-${sttIndex}`,
                                                      class: "font-normal"
                                                    }, _toDisplayString(sttIndex + 1), 9, ["for"])
                                                  ])
                                                ]),
                                                (!_ctx.isDashboardOutgoing)
                                                  ? (_openBlock(), _createBlock("td", _hoisted_46, _toDisplayString(stt.noManifest), 1))
                                                  : _createCommentVNode("", true),
                                                _createVNode("td", _hoisted_47, [
                                                  _createVNode("div", _hoisted_48, [
                                                    _createVNode("span", _hoisted_49, _toDisplayString(stt.sttNo), 1),
                                                    (stt.isAggregator)
                                                      ? (_openBlock(), _createBlock("span", _hoisted_50, "Aggregator"))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]),
                                                _createVNode("td", _hoisted_51, _toDisplayString(stt.productType), 1),
                                                _createVNode("td", _hoisted_52, [
                                                  _createVNode("span", {
                                                    class: ["font-normal text-sm py-0.5 px-2 rounded-md", `${_ctx.mapHangingDays(stt).color}`]
                                                  }, _toDisplayString(_ctx.mapHangingDays(stt).label), 3)
                                                ]),
                                                (_ctx.isDashboardOutgoing)
                                                  ? (_openBlock(), _createBlock("td", _hoisted_53, _toDisplayString(stt.destination), 1))
                                                  : _createCommentVNode("", true),
                                                _createVNode("td", _hoisted_54, [
                                                  _createVNode("div", _hoisted_55, [
                                                    _createVNode("span", {
                                                      class: ["font-normal text-sm py-0.5 px-2 rounded-2xl", `${_ctx.mapTicketStatus(stt).color}`]
                                                    }, _toDisplayString(_ctx.mapTicketStatus(stt).label), 3),
                                                    (
                                  stt.existenceStatus !== 'belum_ditemukan' &&
                                    stt.existenceStatus
                                )
                                                      ? (_openBlock(), _createBlock("span", _hoisted_56, _toDisplayString(stt.existenceUsername) + " - " + _toDisplayString(stt.existenceFindAt
                                    ? stt.existenceFindAt
                                    : ""), 1))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]),
                                                _createVNode("td", _hoisted_57, _toDisplayString(stt.existenceLocationNote || stt.existenceLocation || '-'), 1)
                                              ]))
                                            }), 128))
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["onTabOpen", "onTabClose"]))
          }), 128))
        ])),
    _createVNode(_component_ConfirmAction, {
      modelValue: _ctx.isOpenModal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpenModal = $event)),
      title: _ctx.$t('dashboard.cardCollapsibleHanging.confirmDoneTitle'),
      textSuccess: _ctx.$t('dashboard.cardCollapsibleHanging.yesDone'),
      messageHtml: _ctx.$t('dashboard.cardCollapsibleHanging.confirmDoneMessage'),
      textCancel: _ctx.$t('dashboard.cardCollapsibleHanging.cancel'),
      onConfirm: _ctx.onDone
    }, null, 8, ["modelValue", "title", "textSuccess", "messageHtml", "textCancel", "onConfirm"])
  ]))
}